import React, { useState } from 'react';
import { Button, Modal } from 'antd';
import { InfoCircleTwoTone } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { ISaveModalProps } from 'store/ducks/Global/types';
import * as Styled from './SaveModal.styled';

const SaveModal: React.FC<ISaveModalProps> = ({
  width,
  modalOpen,
  handleOpen,
  handleCancel,
  handleDiscard,
  handleOk,
  children,
  ...rest
}) => {
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();

  return (
    <Modal
      open={modalOpen}
      title={
        <Styled.StyledTitle>
          <InfoCircleTwoTone twoToneColor='#faad14' />
          {t('SAVE_MODAL_TITLE')}
        </Styled.StyledTitle>
      }
      onOk={handleOk}
      onCancel={handleCancel}
      footer={[
        <Button key='back' onClick={handleCancel}>
          {t('SAVE_MODAL_RETURN')}
        </Button>,
        <Button
          key='submit'
          type='default'
          loading={loading}
          onClick={handleDiscard}
        >
          {t('SAVE_MODAL_DISCARD')}
        </Button>,
        <Button key='link' type='primary' loading={loading} onClick={handleOk}>
          {t('SAVE')}
        </Button>
      ]}
      {...rest}
    >
      <p>{t('SAVE_MODAL_CONTENT')}</p>
    </Modal>
  );
};

export default SaveModal;
